import { language as lan_generatePending } from "./generate-pending/index";
import { language as lan_orderPool } from "./order-pool/index"
import { language as lan_productManager } from "./product-manager/index";

let language = {
    ...lan_generatePending,
    ...lan_orderPool,
    ...lan_productManager,

}

export { language }